import { ReactComponent as MapMarkerSvg } from '../../assets/icons/map-marker.svg';

export const MapMarkerIcon: SvgIcon = (props) => {
    return <MapMarkerSvg {...props} />;
};
